/**
 * Journal Question Type Constants
 *
 * These constants correspond to the question types defined in the database migration
 * (appmed.migrations/1749756733_Journals.cs, updated by
 * appmed.migrations/1789662908_AddNumericScaleJournalQuestionType.cs) and should be
 * kept in sync.
 *
 * Database Question Types:
 * 1 = 'Oui/Non' / 'Yes/No'
 * 2 = 'Oui/Non avec échelle souriante' / 'Yes/No with Smiley Scale' (emoji scale from 0 to 10)
 * 3 = 'Oui/Non avec nombre' / 'Yes/No with Count'
 * 4 = 'Multiselect conditionnel' / 'Conditional Multiselect'
 * 5 = REMOVED - 'Échelle avec émojis' / 'Scale with Emojis'
 * 6 = 'Sélection multiple' / 'Multi Select'
 * 7 = 'Texte libre' / 'Free Text'
 * 8 = 'Échelle' / 'Scale'
 * 9 = 'Bascule' / 'Toggle'
 * 10 = 'Oui/Non avec échelle numérique' / 'Yes/No with Numeric Scale' (configurable range, numbers only)
 */
export const QUESTION_TYPE_IDS = {
  /** Simple yes or no question */
  YES_NO: 1,

  /** Yes/No question with smiley (emoji) scale from 0 to 10 if yes */
  YES_NO_WITH_SCALE: 2,

  /** Yes/No question with count if yes */
  YES_NO_WITH_COUNT: 3,

  /** Multiselect question with conditional sub-questions */
  CONDITIONAL_MULTISELECT: 4,

  /** Multiple selection with custom options */
  MULTI_SELECT: 6,

  /** Free text response */
  FREE_TEXT: 7,

  /** Simple scale question */
  SCALE: 8,

  /** Toggle button with configurable label */
  TOGGLE: 9,

  /** Yes/No question with configurable numeric-only scale if yes */
  YES_NO_WITH_NUMERIC_SCALE: 10,
} as const;
